import { Component, OnInit,OnDestroy,Input,Output,EventEmitter,HostListener } from '@angular/core';
import {ExamsService} from '../exams.service';
import {GalleryService} from '../gallery.service';
import { Subscription } from 'rxjs';
import { UntypedFormBuilder } from '@angular/forms';
import { LoginService } from '../login.service';
import { ViewerItem } from '../media-viewer/media-viewer.component';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    standalone: false
})
export class GalleryComponent implements OnInit,OnDestroy {
  src:string;
  imgct:number;
  clipct:number;
  fullct: number;
  pdfct: number;
  timelinect: number;
  dwonloadImageCt: number;
  view = 'Groups';
  _albums = [];
  _clips = [];
  _fulls= [];
  _timeline= [];
  _pdfs=[];
  @Input('forprint') forPrint: boolean;
  @Input('inbox') inbox: number;
  /** The viewer offers Delete (the exam's gallery popup). */
  @Input() deletable = false;
  @Output() closed = new EventEmitter<null>();
  private meadiaSub: Subscription;
  invalidi = '';
  download=false;
  image;

  // What the menu's All / Images / Clips / PDFs buttons show (By Type only).
  show: 'all' | 'img' | 'clip' | 'pdf' = 'all';

  // One viewer for images, clips, recordings and PDFs.
  viewerOpen = false;
  viewerItems: ViewerItem[] = [];
  viewerIndex = 0;
  /** Which list the viewer steps through, so it can be rebuilt after a delete. */
  private viewerSource: 'groups' | 'timeline' | 'pdf' | 'grid' = 'groups';
  deleting = false;
  deleteFailed = false;
  /** The shortcuts are open, and where from (null = closed). */
  helpFrom: 'gallery' | 'viewer' | 'grid' = null;

  // Clips picked to play together, place by place in the grid (null = an empty place). Kept by the
  // clip's address, not its position: deleting a clip shifts every later position by one.
  static readonly MAX_GRID = 4;
  readonly maxGrid = GalleryComponent.MAX_GRID;
  gridSlots: string[] = [];
  selectLimitHit = false;
  gridOpen = false;
  /** gridSlots as clips, for the grid. */
  gridPlaces: ViewerItem[] = [];
  /** Every clip, for the grid's strip. */
  allClips: ViewerItem[] = [];
  marquee: { left: number; top: number; width: number; height: number } = null;
  private drag: { area: HTMLElement; x: number; y: number; moved: boolean; id: number; before: string[] } = null;
  private dragJustEnded = false;
  private limitTimer: any;

  constructor(public ls:LoginService,public es: ExamsService, public gs: GalleryService, public fb:UntypedFormBuilder) {
    this.gs.isOpen = false;
    this.gs.showSelect = false;
    this.resetImage();
  }

  resetImage(){
    this.image = this.fb.group({
      AutoIndex:[''],
      text:['']
    })
  }

  ngOnInit() {
    this.src="";
    this.imgct=0;
    this.clipct=0;
    this.fullct=0;
    this.timelinect=0;
    this.pdfct = 0;
    this.dwonloadImageCt=0;
    if(this.gs.HasDemos){
      switch(this.es.ExamType){
        case 'NT':
          this.src='NT';
          this.imgct=7;
          break;
        case 'Early':
          this.src='Early';
          this.imgct=31;
          this.clipct=5;
          break;
        case 'Late':
          this.src='Late';
          this.imgct=23;
          this.clipct=5;
      }

      for (let i = 1; i <= this.imgct; i++) {
        const src = '../../assets/demo/'+this.src+'/'+i+'.jpg'
        const thumb = '../../assets/demo/'+this.src+'/thumbs/'+i+'.jpg'
        this._albums.push({ src: src, thumb: thumb });
      }

      for (let i = 1; i <= this.clipct; i++) {
        const src = '../../assets/demo/'+this.src+'/clips/'+i+'.mp4'
        const thumb = '../../assets/demo/'+this.src+'/clips/thumbs/'+i+'.jpg'
        this._clips.push({ src: src, thumb: thumb });
      }
      this.allClips = this._clips.map((_, i) => this.clipItem(i));
    }
    else{
      this.loadGallery();
    }


    if(! this.es.isClosed){
      this.meadiaSub = this.es.mediaArrived$.subscribe((mtype)=>{
        if(mtype != 'html')
          this.loadGallery();
      });
    }

  }

  ngOnDestroy(): void {
    if(this.meadiaSub)
      this.meadiaSub.unsubscribe();
    this.gs.isOpen = false;
  }

  loadGallery(done: () => void = null, fail: () => void = null){
    this.gs.getGallery(()=>{
      // Runs again whenever media arrives during the exam: start from empty, or every list is
      // appended to and thumbnail i opens a different item.
      this._albums = []; this._clips = []; this._fulls = []; this._pdfs = []; this._timeline = [];
      for (let i = 0; i < this.gs.Images.length; i++) {
        const src = '/api/getmedia/'+this.gs.Images[i][0]+'/n';
        const thumb = `/api/getmedia/${this.gs.Images[i][0]}/y`;
        const text = this.gs.Images[i][2]
        this._albums.push({ src: src, thumb: thumb, text: text });
      }
      this.imgct = this.gs.Images.length;
      this.dwonloadImageCt = this.gs.imageSelection.value.filter((i) => i === true).length;
      this.gs.imageSelection.valueChanges.subscribe((res) => {
        this.dwonloadImageCt =res.filter((i) => i === true).length
      })

      for (let i = 0; i < this.gs.Clips.length; i++) {
        const src = '/api/getmedia/'+this.gs.Clips[i]+'/n';
        const thumb =  '/api/getmedia/'+this.gs.Clips[i]+'/y';
        this._clips.push({ src: src, thumb: thumb });
      }
      this.clipct = this.gs.Clips.length;
      this.allClips = this._clips.map((_, i) => this.clipItem(i));
      // a deleted clip leaves the selection; the others keep their places
      this.setSlots(this.gridSlots.map((k) => (k !== null && this.clipIndex(k) >= 0 ? k : null)));

      for (let i = 0; i < this.gs.Fulls.length; i++) {
        const src = '/api/getmedia/'+this.gs.Fulls[i]+'/n';
        const thumb =  '/api/getmedia/'+this.gs.Fulls[i]+'/y';
        this._fulls.push({ src: src, thumb: thumb });
      }

      this.fullct = this.gs.Fulls.length;
      this.pdfct = this.gs.PDFs.length;
      for (let i = 0; i < this.gs.PDFs.length; i++) {
        const src = '/api/getmedia/'+this.gs.PDFs[i]+'/n';
        const thumb =  '/api/getmedia/'+this.gs.PDFs[i]+'/y';
        this._pdfs.push({ src: src, thumb: thumb });
      }

      for (let i = 0; i < this.gs.Timeline.length; i++) {
        if( Array.isArray(this.gs.Timeline[i])){
          const src = '/api/getmedia/'+this.gs.Timeline[i][0]+'/n';
          const thumb = `/api/getmedia/${this.gs.Timeline[i][0]}/y`;
          const text = this.gs.Timeline[i][2]
          this._timeline.push({ src: src, thumb: thumb, text: text });
        }else{
          const src = '/api/getmedia/'+this.gs.Timeline[i]+'/n';
          const thumb =  '/api/getmedia/'+this.gs.Timeline[i]+'/y';
          this._timeline.push({ src: src, thumb: thumb });
        }

      }
      this.timelinect = this.gs.Timeline.length;
      if (done) done();
    }, this.inbox, fail);
  }

  // ---------------------------------------------------------------- the viewer's list
  // The viewer steps through what the gallery shows, in the order it shows it.

  private imageItem(i: number, group?: string): ViewerItem {
    return { kind: 'img', src: this._albums[i].src, thumb: this._albums[i].thumb, label: 'Image ' + (i + 1), group, mediaIndex: i };
  }
  private clipItem(i: number, group?: string): ViewerItem {
    return { kind: 'clip', src: this._clips[i].src, thumb: this._clips[i].thumb, label: 'Clip ' + (i + 1), group, mediaIndex: i };
  }
  private fullItem(i: number, group?: string): ViewerItem {
    return { kind: 'full', src: this._fulls[i].src, thumb: this._fulls[i].thumb, label: 'Recording ' + (i + 1), group, mediaIndex: i };
  }

  /** Images, then clips, then (outside cardio) full recordings - as far as the menu shows them. */
  private groupsSequence(): ViewerItem[] {
    const onlyImages = this.forPrint || this.gs.showSelect;
    const items: ViewerItem[] = [];
    if (this.show === 'all' || this.show === 'img' || onlyImages)
      this._albums.forEach((_, i) => items.push(this.imageItem(i, 'Images')));
    if (!onlyImages && (this.show === 'all' || this.show === 'clip')) {
      this._clips.forEach((_, i) => items.push(this.clipItem(i, 'Clips')));
      if (!this.ls.isCardio) this._fulls.forEach((_, i) => items.push(this.fullItem(i, 'Recordings')));
    }
    return items;
  }

  /** The timeline in recording order. Its positions are not the image / clip indexes Delete uses. */
  private timelineSequence(): ViewerItem[] {
    return this._timeline.map((t, k) => {
      const entry = this.gs.Timeline[k];
      if (Array.isArray(entry)) {
        const i = this.gs.Images.findIndex((im) => im[0] == entry[0]);
        return { kind: 'img', src: t.src, thumb: t.thumb, label: 'Image ' + (i + 1), mediaIndex: i } as ViewerItem;
      }
      const c = this.gs.Clips.findIndex((x) => x == entry);
      return { kind: 'clip', src: t.src, thumb: t.thumb, label: 'Clip ' + (c + 1), mediaIndex: c } as ViewerItem;
    });
  }

  private pdfSequence(): ViewerItem[] {
    return this._pdfs.map((p, i) => ({ kind: 'pdf', src: p.src, thumb: p.thumb, label: 'Document ' + (i + 1), mediaIndex: i } as ViewerItem));
  }

  private sequence(source: 'groups' | 'timeline' | 'pdf' | 'grid'): ViewerItem[] {
    switch (source) {
      case 'timeline': return this.timelineSequence();
      case 'pdf': return this.pdfSequence();
      case 'grid': return this.gridPlaces.filter((c) => c);
      default: return this.groupsSequence();
    }
  }

  private openSequence(source: 'groups' | 'timeline' | 'pdf' | 'grid', at: number): void {
    if (this.dragJustEnded || at < 0) return;
    this.viewerSource = source;
    this.viewerItems = this.sequence(source);
    this.viewerIndex = at;
    this.viewerOpen = true;
    this.deleteFailed = false;
    this.gs.isOpen = true;
  }

  /** An image in By Type, or any item in Timeline (by its timeline position). */
  open(index: number): void {
    if (this.view == 'Timeline') {
      this.openSequence('timeline', index);
    } else {
      this.openSequence('groups', this.groupsSequence().findIndex((s) => s.kind === 'img' && s.mediaIndex === index));
    }
  }

  openClip(index: number, full = false): void {
    if (this.view == 'Timeline') { this.open(index); return; }
    this.openSequence('groups', this.groupsSequence().findIndex((s) => s.kind === (full ? 'full' : 'clip') && s.mediaIndex === index));
  }

  openPDF(index: number): void {
    this.openSequence('pdf', index);
  }

  /**
   * Delete from the viewer: once the server has answered, the gallery reloads and the viewer stays
   * open on the item that took the deleted one's place (the previous one at the end, closed when
   * nothing is left). A deleted clip also leaves the grid.
   */
  removeMedia(item: ViewerItem): void {
    if (this.deleting) return;
    this.deleting = true;
    this.deleteFailed = false;
    const failed = (err?: any) => {
      if (err) console.log(err);
      this.deleting = false;
      this.deleteFailed = true;
    };
    // where it was in the viewer's list - the viewer may have stepped away from where it opened
    const at = Math.max(0, this.viewerItems.indexOf(item));
    this.gs.delete(item.kind, item.mediaIndex).subscribe(() => {
      this.loadGallery(() => {
        this.deleting = false;
        const items = this.sequence(this.viewerSource);
        if (!items.length) { this.closeViewer(); return; }
        this.viewerItems = items;
        this.viewerIndex = Math.min(at, items.length - 1);
      }, () => failed());
    }, failed);
  }

  closeViewer(): void {
    this.viewerOpen = false;
    this.deleting = false;
    this.deleteFailed = false;
    this.gs.isOpen = false;
  }

  pdfDifTab(index: number) {
    //opens the pdf in another tab
    window.open('api/getmedia/'+this.gs.PDFs[index]+'/n','_blank');
  }

  close(): void {
    this.viewerOpen = false;
    this.gs.isOpen=false;
    this.gs.showSelect =false;
  }

  openHelp(from: 'gallery' | 'viewer' | 'grid'): void { this.helpFrom = from; }

  // ? opens the shortcuts from wherever the user is - but not while typing (the image notes, a field
  // behind the popup). preventDefault marks the key as taken, should a second gallery be on the page.
  @HostListener('document:keydown', ['$event'])
  onKey(e: KeyboardEvent): void {
    if (e.key !== '?' || e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || this.forPrint || this.helpFrom) return;
    const t = e.target as HTMLElement;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    e.preventDefault();
    this.openHelp(this.viewerOpen ? 'viewer' : this.gridOpen ? 'grid' : 'gallery');
  }

  setView(v: string): void {
    this.view = v;
    this.show = 'all';
  }

  // ---------------------------------------------------------------- clips in a grid
  private clipKey(i: number): string { return this._clips[i].src; }
  private clipIndex(key: string): number { return this._clips.findIndex((c) => c.src === key); }
  get selectedCount(): number { return this.gridSlots.filter((k) => k !== null).length; }
  isSelected(i: number): boolean { return this.gridSlots.includes(this.clipKey(i)); }

  /** Puts a clip in the first empty place, or after the others; false when the grid is full. */
  private addSlot(slots: string[], key: string): boolean {
    if (slots.filter((k) => k !== null).length >= GalleryComponent.MAX_GRID) return false;
    const hole = slots.indexOf(null);
    if (hole >= 0) slots[hole] = key; else slots.push(key);
    return true;
  }

  // One or two clips sit side by side, so they have no empty place. Three or four keep their places
  // on the 2x2 grid: taking one out leaves its place empty instead of moving the others.
  private setSlots(slots: string[]): void {
    const keys = slots.filter((k) => k !== null);
    slots = keys.length <= 2 ? keys : slots.slice(0, GalleryComponent.MAX_GRID);
    while (slots.length && slots[slots.length - 1] === null) slots.pop();
    this.gridSlots = slots;
    this.gridPlaces = slots.map((k) => (k === null ? null : this.clipItem(this.clipIndex(k))));
  }

  private toggleKey(key: string): void {
    const slots = [...this.gridSlots];
    const at = slots.indexOf(key);
    if (at >= 0) slots[at] = null;
    else if (!this.addSlot(slots, key)) { this.flashLimit(); return; }
    this.setSlots(slots);
  }

  toggleClip(i: number, e?: Event): void {
    if (e) e.stopPropagation();
    if (i >= 0) this.toggleKey(this.clipKey(i));
  }

  clearClips(): void { this.setSlots([]); }

  private flashLimit(): void {
    this.selectLimitHit = true;
    clearTimeout(this.limitTimer);
    this.limitTimer = setTimeout(() => (this.selectLimitHit = false), 2500);
  }

  openGrid(): void {
    if (this.selectedCount) this.gridOpen = true;
  }
  /** A clip clicked in the grid opens alone; the arrows then step between the grid's clips. */
  openFromGrid(item: ViewerItem): void {
    this.openSequence('grid', this.sequence('grid').findIndex((c) => c.src === item.src));
  }
  /** Added from the grid's strip, or taken out (strip or ×). The grid stays open, even empty. */
  toggleInGrid(item: ViewerItem): void { this.toggleKey(item.src); }
  /** A clip dragged to another place: onto a clip the two swap, onto an empty place it moves there. */
  moveInGrid(m: { from: number; to: number }): void {
    const slots = [...this.gridSlots];
    const size = this.selectedCount <= 2 ? this.selectedCount : GalleryComponent.MAX_GRID;
    while (slots.length < size) slots.push(null);
    if (m.from >= size || m.to >= size) return;
    [slots[m.from], slots[m.to]] = [slots[m.to], slots[m.from]];
    this.setSlots(slots);
  }

  // Drag across clips to select them: a press that moves more than a few pixels draws a rectangle,
  // and every clip it touches joins the selection. A press that does not move is an ordinary click.
  dragStart(e: PointerEvent, area: HTMLElement): void {
    if (e.button !== 0 || this.forPrint || this.gs.showSelect) return;
    const r = area.getBoundingClientRect();
    this.drag = { area, x: e.clientX - r.left, y: e.clientY - r.top, moved: false, id: e.pointerId, before: [...this.gridSlots] };
  }
  dragMove(e: PointerEvent): void {
    const d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    const r = d.area.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    if (!d.moved && Math.hypot(x - d.x, y - d.y) < 8) return;
    if (!d.moved) { d.moved = true; d.area.setPointerCapture(e.pointerId); }
    const box = { l: Math.min(x, d.x), t: Math.min(y, d.y), r: Math.max(x, d.x), b: Math.max(y, d.y) };
    this.marquee = { left: box.l, top: box.t, width: box.r - box.l, height: box.b - box.t };
    const next = [...d.before];
    d.area.querySelectorAll<HTMLElement>('[data-clip]').forEach((el) => {
      const i = Number(el.dataset['clip']);
      if (i < 0 || next.includes(this.clipKey(i))) return;
      const er = el.getBoundingClientRect(), l = er.left - r.left, t = er.top - r.top;
      if (l < box.r && l + er.width > box.l && t < box.b && t + er.height > box.t) {
        if (!this.addSlot(next, this.clipKey(i))) this.flashLimit();
      }
    });
    this.setSlots(next);
  }
  dragEnd(e: PointerEvent): void {
    const d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    this.drag = null;
    this.marquee = null;
    if (d.moved) {
      // the click that follows a drag must not open the clip it ended on
      this.dragJustEnded = true;
      setTimeout(() => (this.dragJustEnded = false));
    }
  }

  assign(){
    this.gs.assignInbox(this.inbox);
    this.closed.emit();
  }

  checkArray(item){
    return Array.isArray(item)
  }

}
